const TrendsSuggestionsSkeletonContainer = () => {
    return <>
        <div className="suggestions-skeleton-screen trends-skeleton-screen">
            <div className="skeleton heading-title"></div>
            <hr className="custom-hr" />

            <div className="skeleton skeleton-trend-item"></div>
            <div className="skeleton skeleton-trend-item"></div>
            <div className="skeleton skeleton-trend-item"></div>
            <div className="skeleton skeleton-trend-item"></div>
            <div className="skeleton skeleton-trend-item"></div>
            <div className="skeleton skeleton-trend-item"></div>
            
        </div> 
    </>
}

export default TrendsSuggestionsSkeletonContainer;
